module.exports = __webpack_public_path__ + "img/logo.41f1db9f.png";